import axios from 'axios'
import { Message } from 'element-ui'
import apiEnv from '@/api/env'
import { clearAuthStorage, getToken } from './auth'

// 避免登录失效时重复跳转，造成多次错误提示和页面抖动
let isRedirecting = false

// axios 二次封装：统一表单编码、Admin-Token 鉴权头、响应体解包与错误提示
const service = axios.create({
    baseURL: apiEnv.baseURL,
    timeout: 180000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})

service.interceptors.request.use(
    config => {
        // 后端 /qw-admin/** 通过 Admin-Token 请求头解析当前登录管理员身份
        const token = getToken()
        if (token) {
            config.headers['Admin-Token'] = token
        }
        return config
    },
    error => Promise.reject(error)
)

service.interceptors.response.use(
    response => {
        const res = response.data || {}
        // 后端统一使用 status/result/msg/data 结构，成功时直接返回业务体
        if (res.status === 200 && res.result === 'success') {
            return res
        }

        const message = res.msg || res.message || '请求失败，请稍后重试'
        Message.error(message)

        // 登录失效（401/提示重新登录）时清理本地登录态并回到登录页
        if (res.status === 401 || message.includes('重新登录')) {
            clearAuthStorage()
            if (!isRedirecting && window.location.hash !== '#/login') {
                isRedirecting = true
                window.location.hash = '#/login'
                window.setTimeout(() => {
                    isRedirecting = false
                }, 300)
            }
        }

        return Promise.reject(new Error(message))
    },
    error => {
        // 优先提取后端返回的业务错误信息（如 HTTP 401/500 时后端仍返回 JSON）
        const resData = error.response && error.response.data
        const message = (resData && (resData.message || resData.msg)) || error.message || '网络异常，请稍后重试'
        Message.error(message)

        // 拦截器返回 401 时同样清理登录态
        if (error.response && error.response.status === 401) {
            clearAuthStorage()
            if (!isRedirecting && window.location.hash !== '#/login') {
                isRedirecting = true
                window.location.hash = '#/login'
                window.setTimeout(() => {
                    isRedirecting = false
                }, 300)
            }
        }
        return Promise.reject(error)
    }
)

export default service
